import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M9.95397 14.9544V9.04466L15.1822 11.999L9.95397 14.9544ZM21.5824 7.18539C21.3523 6.32571 20.6745 5.64742 19.8132 5.41682C18.2546 5 11.999 5 11.999 5C11.999 5 5.74539 5 4.18586 5.41682C3.3255 5.64742 2.6477 6.32571 2.41659 7.18539C2 8.74459 2 11.999 2 11.999C2 11.999 2 15.2544 2.41659 16.8146C2.6477 17.6743 3.3255 18.3516 4.18586 18.5832C5.74539 19 11.999 19 11.999 19C11.999 19 18.2546 19 19.8132 18.5832C20.6745 18.3516 21.3523 17.6743 21.5824 16.8146C22 15.2544 22 11.999 22 11.999C22 11.999 22 8.74459 21.5824 7.18539Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconSocialYoutube = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconSocialYoutube.displayName = "IconSocialYoutube";

export { IconSocialYoutube };
